import ErrorIcon from 'assets/svg/error/error-sm.svg'
import PointIcon from 'assets/svg/profile/point.svg'
import Flex from 'common/components/Flex'
import Skeleton from 'common/components/Skeleton'
import Typography from 'common/components/Typography'
import { WEB_DESKTOP_RALALI_URL } from 'common/constants'
import theme from 'common/theme'
import CurrencyFormatter from 'lib/currency-formatter'
import { useEffect } from 'react'
import { useStoreActions, useStoreState } from 'stores/hooks'
import styled from 'styled-components'

const MenuLink = styled.a`
  ${theme.typography.rsubtitle}
  display: flex;
  padding: 8px;
  margin: 2px;
  align-items: center;
  color: ${theme.colors.black};
  border-radius: ${theme.radius.base};
  :hover {
    background-color: ${theme.colors.grayLighter};
  }
`

const StyledPointIcon = styled(PointIcon)`
  margin-right: 12px;
`

const StyledErrorIcon = styled(ErrorIcon)`
  color: ${theme.colors.red};
  margin-right: 4px;
`

const MenuLinkContent = styled(Flex)`
  flex: 1 0 auto;
`

function MenuPoints(): JSX.Element {
  const {
    data,
    isError,
    isLoading,
    alreadyGetPoints,
  } = useStoreState((state) => state.points)

  const { getPoints } = useStoreActions((actions) => actions.points)

  useEffect(() => {
    if (!alreadyGetPoints) getPoints({})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <MenuLink
      {...(!isLoading && {
        href: `${WEB_DESKTOP_RALALI_URL}/ralalipoin`,
      })}
    >
      {isLoading && <Skeleton height="19px" />}
      {!isLoading && (
        <>
          <StyledPointIcon />
          <MenuLinkContent
            justifyContent="space-between"
            alignItems="center"
          >
            <span>Point</span>
            {isError ? (
              <Flex alignItems="center">
                <StyledErrorIcon />
                <Typography
                  type="bsubtitle"
                  color="red"
                  fontSize="11px"
                  fontWeight="normal"
                >
                  Dalam Perbaikan
                </Typography>
              </Flex>
            ) : (
              <Typography type="bsubtitle" color="orange">
                {`${CurrencyFormatter(data, undefined, {
                  minimumFractionDigits: 0,
                })} Point`}
              </Typography>
            )}
          </MenuLinkContent>
        </>
      )}
    </MenuLink>
  )
}

export default MenuPoints
